import React, { forwardRef } from 'react';
import { Helmet } from 'react-helmet-async';

import { cn } from '../../utils';

export const Page = forwardRef(
  (
    {
      children,
      title,
      className,
    }: { children: React.ReactNode; title?: string; className?: string },
    ref,
  ) => {
    return (
      <div
        ref={ref as React.RefObject<HTMLDivElement>}
        className={cn('container p-8 flex-1 min-h-0 flex flex-col', className)}
      >
        <Helmet>
          <title>
            {title ? `autone.io | ${title.toLowerCase()}` : 'autone.io'}
          </title>
        </Helmet>
        {children}
      </div>
    );
  },
);
